import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import {
  Panel,
  IconButton,
  Icon,
  Form,
  FormGroup,
  ControlLabel,
  Radio,
  RadioGroup,
  Input,
} from 'rsuite'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'

export default function SumamaryProposalFilterWidget({
  schema,
  register,
  Controller,
  control,
  errors,
}) {
  const [radio, setRadio] = useState(1)
  const myRef = useRef(null)

  console.log('schema => ', schema)

  return (
    <>
      <Panel
        header={schema?.header}
        bordered
        defaultExpanded
        collapsible
        shaded
        style={{ marginBottom: '20px' }}
      >
        <Form fluid>
          <FormGroup>
            <ControlLabel>{schema?.summaryInput?.label}</ControlLabel>
            <Input
              name={schema?.summaryInput?.name}
              defaultValue={schema?.summaryInput?.value}
              componentClass="textarea"
              disabled={schema?.summaryInput?.disabled}
            />
          </FormGroup>
          <br />
        </Form>
      </Panel>
    </>
  )
}
